module.exports = __webpack_public_path__ + "img/fye-calander.658504f8.svg";